'use client'

import { useIsMobile } from '@chain-zen/ui'
import { Suspense } from 'react'

import { ChainLoader } from '../../../../components/chain-loader'
import { BackhaulPosts } from '../../../../components/shipment-backhauls'
import type { IShipment } from '../../../../types/shipment'
import { Details } from './details'
import { FilesDetails } from './details/files-details'
import { ReferenceDetails } from './details/reference-details'
import { Stops } from './stops'
import { StopsProvider } from './stops/contexts/use-stops-context'
import { Tracking } from './tracking'

interface ShipmentOverviewSectionsProps {
  backhaulPostsView?: 'card' | 'table'
  isUserAdminOrOwner?: boolean
  shipment: IShipment
}

export const ShipmentOverviewSections = ({
  shipment,
  isUserAdminOrOwner,
  backhaulPostsView
}: ShipmentOverviewSectionsProps) => {
  const isMobile = useIsMobile()
  const isShipmentOwner = shipment.isShipmentOwner === true
  const hasTrackingSection = Array.isArray(shipment.stops)
  const stops = shipment.stops ?? []
  const resolvedBackhaulPostsView = backhaulPostsView ?? (isMobile ? 'card' : 'table')

  return (
    <div className="space-y-4">
      <Details shipment={shipment} />

      {hasTrackingSection ? (
        <Suspense fallback={<ChainLoader />}>
          <Tracking
            drivers={shipment.drivers}
            shipmentID={shipment.id}
            stops={stops}
            shipmentNumber={shipment.shipmentNumber}
            shipmentOwnerEnterpriseWorkspaceID={shipment.shipmentOwnerWorkspace?.enterpriseWorkspaceID ?? undefined}
            shipmentOwnerWorkspaceID={shipment.shipmentOwnerWorkspace?.id}
            isUserAdminOrOwner={isUserAdminOrOwner}
          />
        </Suspense>
      ) : null}

      {!isShipmentOwner ? <BackhaulPosts shipment={shipment} postsView={resolvedBackhaulPostsView} /> : null}

      <ReferenceDetails shipment={shipment} />
      {isShipmentOwner ? <FilesDetails shipment={shipment} /> : null}

      <StopsProvider shipment={shipment}>
        <Stops />
      </StopsProvider>
    </div>
  )
}
